import { API } from '@shared/types/api';

export interface PendingUsersNotice {
  channelSlug: string;
  messageId: number;
  users: API.ShortUserFragment[];
}

type PendingUsersNoticeListener = (notice: PendingUsersNotice) => void;

const listeners = new Set<PendingUsersNoticeListener>();

export function subscribePendingUsersNotice(listener: PendingUsersNoticeListener): VoidFunction {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function emitPendingUsersNotice(notice: PendingUsersNotice) {
  listeners.forEach(listener => listener(notice));
}
